import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { CountedAmountInput } from "./CountedAmountInput";
import { TransactionList } from "./TransactionList";
import { TotalAmount } from "./TotalAmount";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { SelectAllTransactions } from "./transaction-selection/SelectAllTransactions";
import { Transaction } from "../types/TransactionTypes";

interface PaymentMethodCardProps {
  method: string;
  amount: number;
  counted?: number;
  transactions?: Transaction[];
  onCountedChange: (value: string) => void;
  isExpanded: boolean;
  onToggleExpand: () => void;
  isValidated?: boolean;
  onTransactionSelect?: (transactionId: string, checked: boolean) => void;
  selectedTransactions?: Set<string>;
}

export const PaymentMethodCard = ({
  method,
  amount,
  counted,
  transactions = [],
  onCountedChange,
  isExpanded,
  onToggleExpand,
  isValidated,
  onTransactionSelect,
  selectedTransactions = new Set(),
}: PaymentMethodCardProps) => {
  const [showDetails, setShowDetails] = useState(false);
  const isEspeces = method.toLowerCase() === "espèces";

  return (
    <Card className={method === "Crédit" ? "border-orange-500" : undefined}>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center justify-between">
          <span>{method}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <Label className="text-sm text-gray-500">Montant total</Label>
            <TotalAmount
              amount={amount}
              counted={counted}
              isValidated={isValidated}
              transactions={transactions}
            />
          </div>

          <CountedAmountInput
            method={method}
            counted={counted}
            amount={amount}
            onChange={onCountedChange}
          />

          {transactions && transactions.length > 0 && (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowDetails(!showDetails)}
                className="w-full flex items-center justify-center"
              >
                {showDetails ? (
                  <>
                    <ChevronUp className="h-4 w-4 mr-2" />
                    Masquer les détails
                  </>
                ) : (
                  <>
                    <ChevronDown className="h-4 w-4 mr-2" />
                    Voir les détails ({transactions.length})
                  </>
                )}
              </Button>

              {showDetails && (
                <div className="mt-4 space-y-2">
                  <Label className="text-sm text-gray-500">Transactions</Label>
                  {isEspeces && onTransactionSelect && (
                    <SelectAllTransactions
                      method={method}
                      transactions={transactions}
                      selectedTransactions={selectedTransactions}
                      onTransactionSelect={onTransactionSelect}
                    />
                  )}
                  <TransactionList
                    transactions={transactions}
                    showCheckbox={isEspeces}
                    onTransactionSelect={onTransactionSelect}
                    selectedTransactions={selectedTransactions}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
};